import { Ref } from '@nuxtjs/composition-api';
import { UA } from 'nuxt-user-agent/lib/types';

import IDropdownItem from '../types/IDropdownItem';

export const buildMapContainerClass = (isMobile: Ref<boolean>): string => `biura__map-container${isMobile.value ? ' biura__map-container--mobile' : ''}`;

interface IShouldRenderListStatement {
  wojewodztwo: Ref<IDropdownItem>;
  miasto: Ref<IDropdownItem>;
  szerokoscGeo: Ref<number>;
  dlugoscGeo: Ref<number>;
}

export const checkShouldRenderList = (params: IShouldRenderListStatement): boolean => {
  const {
    wojewodztwo, miasto, szerokoscGeo, dlugoscGeo,
  } = params;

  return !!(
    wojewodztwo.value.Wartosc
    || miasto.value.Wartosc
    || (szerokoscGeo.value !== null && szerokoscGeo.value !== undefined)
    || (dlugoscGeo.value !== null && dlugoscGeo.value !== undefined)
  );
};

export const checkIsMobile = ($ua: UA) => !($ua.isFromPc() || $ua.isFromTablet());
